import { Box, Typography } from "@mui/material"
import HelpIcon from '@mui/icons-material/Help';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import BaseInput from "../BaseInput";

const AgeInput = ({ value = 0, onChange }) => {
  return (
    <Box>
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center'
        }}
      >
        <Typography variant="h4" color="primary.darkGray">
          Age
        </Typography>
        <HelpIcon
          sx={{
            fontSize: '20px',
            color: 'primary.mediumGray',
            ml: '8px'
          }}
        />
      </Box>
      <Box
        sx={{
          mt: '8px',
          display: 'flex',
          boxShadow: '0px 2px 10px 0px #5B87EF33'
        }}
      >
        <Box
          sx={{
            minWidth: '48px',
            height: '47px',
            bgcolor: 'primary.lightGray',
            border: '1px solid',
            borderColor: 'primary.mediumGray',
            borderRight: '0px solid',
            borderRadius: '8px 0 0 8px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            color: 'primary.darkGray',
            cursor: 'pointer'
          }}
          onClick={() => {
            if (value >= 20) {
              onChange(value - 1)
            }
          }}
        >
          <ExpandMoreIcon />
        </Box>
        {/* <BaseInput
          inputStyles={{
            borderRadius: 0
          }}
        /> */}
        {/* <Box
          sx={{
            width: '100%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            height: '47px',
            border: '1px solid',
            borderColor: 'primary.mediumGray',
          }}
        >
          <Typography variant="body" color="primary.mainBlue">{value}</Typography>
        </Box> */}
        <BaseInput
          inputStyles={{
            borderRadius: 0,
            color: '#5B87EF',
          }}
          inputProps={{
            style: {
              textAlign: 'center'
            }
          }}
          fullWidth
          label=''
          name='familyName'
          type='text'
          placeholder='Age'
          value={value}
          onChange={(e) => {
            const age = parseInt(e.target.value) || 0
            if (Number.isInteger(age) && parseInt(age) < 80) {
              onChange(age)
            }
          }}
          required
        />
        <Box
          sx={{
            minWidth: '48px',
            height: '47px',
            bgcolor: 'primary.lightGray',
            border: '1px solid',
            borderColor: 'primary.mediumGray',
            borderLeft: '0px solid',
            borderRadius: '0 8px 8px 0',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            color: 'primary.darkGray',
            cursor: 'pointer'
          }}
          onClick={() => {
            if (value < 150) {
              onChange(value + 1)
            }
          }}
        >
          <ExpandLessIcon />
        </Box>
      </Box>
    </Box>
  )
}

export default AgeInput